import { isNull } from "../../izUtils"

export const axiosError = (error) => {
    console.log(error)
    if (!isNull(error.response.data.message)) {
        alert(error.response.data.message)
    } else {
        alert(error.response.data.error)
    }
}